// extracted by mini-css-extract-plugin
module.exports =  {"search":"toolbarComponent__search"};